import { Button, Menu, BottomNavigation, BottomNavigationAction, Typography, useTheme, Toolbar, Box, AppBar, MenuItem, IconButton, useMediaQuery } from '@mui/material';
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import HomeIcon from '@mui/icons-material/Home';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import DashboardIcon from '@mui/icons-material/Dashboard';
import PersonIcon from '@mui/icons-material/Person';
import InventoryIcon from '@mui/icons-material/Inventory';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import WarningIcon from '@mui/icons-material/Warning';
import logo from '../../assets/Icon2.png';

export default function AdminNavbar() {
  const [value, setValue] = useState(0);
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState(null);
  const isHomePage = window.location.pathname === '/';
  const isProfile = window.location.pathname === '/profile';
  const [userDetails, setUserDetails] = useState(null);

  useEffect(() => {
    const userInfo = JSON.parse(localStorage.getItem('userDetails'));
    setUserDetails(userInfo);

    // Set initial navigation value based on current path
    const path = window.location.pathname;
    if (path.includes('dashboard')) {
      setValue(0);
    } else if (path.includes('order-management') || path.includes('stock/management')) {
      setValue(1);
    } else if (path.includes('shortage-damage')) {
      setValue(1);
    } else if (path.includes('profile')) {
      setValue(2);
    }
  }, []);

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    localStorage.removeItem('userDetails');
    navigate('/');
    handleMenuClose();
  };

  const handleLoginOpen = () => {
    navigate('/login');
  };

  return (
    <Box sx={{ flexGrow: 1 }}>
      {!isHomePage && (
        <AppBar
          sx={{
            backgroundColor: '#fff',
            padding: { xs: '0 1rem', md: '0 1.5rem' },
          }}
        >
          <Toolbar
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              p: { xs: 1, md: 1 },
              maxWidth: { md: '1200px' },
              margin: '0 auto',
              width: '100%',
            }}
          >
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                cursor: 'pointer',
              }}
              onClick={() => navigate('/')}
            >
              <img
                src={logo}
                alt="Inventory ERP Logo"
                style={{ height: '50px', objectFit: 'contain' }}
              />
            </Box>
          </Toolbar>
        </AppBar>
      )}

      <Box
        sx={{
          display: { xs: 'flex', sm: 'none' },
          position: 'relative',
          bottom: 0,
          left: 0,
          width: '100%',
        }}
      >
        {userDetails && (
          <BottomNavigation
            sx={{
              backgroundColor: '#fff',
              position: 'fixed',
              bottom: 0,
              left: 0,
              width: '100%',
              zIndex: 1000,
              "& .Mui-selected": { color: "#007BFF" },
              boxShadow: '0px -2px 10px rgba(0, 0, 0, 0.1)'
            }}
            value={value}
            onChange={(event, newValue) => {
              setValue(newValue);
            }}
            showLabels
          >
            {userDetails?.role === 'admin' && (
              <>
                <BottomNavigationAction
                  onClick={() => navigate('/admin/dashboard')}
                  label="Dashboard"
                  icon={<DashboardIcon />}
                  sx={{ color: 'black', '&.Mui-selected': { color: '#007BFF' } }}
                />
                <BottomNavigationAction
                  onClick={() => navigate('/admin/orders')}
                  label="Orders"
                  icon={<ShoppingCartIcon />}
                  sx={{ color: 'black', '&.Mui-selected': { color: '#007BFF' } }}
                />
                <BottomNavigationAction
                  label="Profile"
                  icon={<PersonIcon />}
                  sx={{ color: 'black', '&.Mui-selected': { color: '#007BFF' } }}
                  onClick={() => navigate('/admin/profile')}
                />
              </>
            )}

            {userDetails?.role === 'production_manager' && (
              <>
                <BottomNavigationAction
                  onClick={() => navigate('/productionmanager/dashboard')}
                  label="Dashboard"
                  icon={<DashboardIcon />}
                  sx={{ color: 'black', '&.Mui-selected': { color: '#007BFF' } }}
                />
                <BottomNavigationAction
                  onClick={() => navigate('/productionmanager/orders-management')}
                  label="Orders"
                  icon={<ShoppingCartIcon />}
                  sx={{ color: 'black', '&.Mui-selected': { color: '#007BFF' } }}
                />
                <BottomNavigationAction
                  label="Profile"
                  icon={<PersonIcon />}
                  sx={{ color: 'black', '&.Mui-selected': { color: '#007BFF' } }}
                  onClick={() => navigate('/productionmanager/profile')}
                />
              </>
            )}

            {userDetails?.role === 'stock_manager' && (
              <>
                <BottomNavigationAction
                  onClick={() => navigate('/storemanager/stockmanagement')}
                  label="Stock"
                  icon={<InventoryIcon />}
                  sx={{ color: 'black', '&.Mui-selected': { color: '#007BFF' } }}
                />
                <BottomNavigationAction
                  onClick={() => navigate('/storemanager/shortage-damage')}
                  label="Shortage"
                  icon={<WarningIcon />}
                  sx={{ color: 'black', '&.Mui-selected': { color: '#007BFF' } }}
                />
                <BottomNavigationAction
                  label="Profile"
                  icon={<PersonIcon />}
                  sx={{ color: 'black', '&.Mui-selected': { color: '#007BFF' } }}
                  onClick={() => navigate('/storemanager/profile')}
                />
              </>
            )}
          </BottomNavigation>
        )}
      </Box>
    </Box>
  );
}
